import { useState } from "react";
import rg_mobi from "../../../assets/images/NewEvent/rg_mobi.webp";
// import rg_pc from "../../../assets/images/NewEvent/rg_pc.webp";
import { FaRegCircleUser } from "react-icons/fa6";
import { MdOutlineMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { Button } from "flowbite-react";
import res_mobi from "../../../assets/images/NewEvent/res_mobi.webp";
import res_pc from "../../../assets/images/NewEvent/res_pc.webp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RegisterNew() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10,11}$/;
    return phoneRegex.test(phone);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    const { name, email, phone } = formData;

    if (!name.trim()) {
      toast.error("Vui lòng nhập họ và tên!");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Vui lòng nhập đúng định dạng email!");
      return;
    }

    if (!validatePhone(phone)) {
      toast.error("Số điện thoại không hợp lệ! Chỉ chấp nhận 10 hoặc 11 số.");
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      toast.success("Đăng ký thành công!");
      setFormData({ name: "", email: "", phone: "" }); // Reset form sau khi gửi thành công
    }, 2000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div
      className="w-full"
      style={{
        backgroundImage: `url(${window.innerWidth < 768 ? res_mobi : res_pc})`,
      }}
    >
      <ToastContainer />
      <div className="w-full mx-auto container px-[20px] py-[20px] grid grid-cols-1 md:grid-cols-2 items-center gap-3 md:gap-6">
        <div className="w-full border border-solid border-white shadow-custom-light bg-white rounded-[16px] px-[24px] py-[40px] flex flex-col gap-3">
          <div className="flex flex-col gap-2">
            <p className="md:text-center text-[#333333] text-[28px] font-semibold">
              Đăng ký nhận bản tin từ{" "}
              <span className="text-[#053CC8]">Blue Rise</span>
            </p>
            <p className="text-[16px] font-normal text-[#333333]">
              Nhận tin tức và cập nhật mới nhất về các xu hướng công nghệ giáo
              dục, sự kiện, và giải pháp quản lý từ{" "}
              <span className="text-[#053CC8]">Blue Rise</span>
            </p>
          </div>
          <div>
            <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
              <FaRegCircleUser className="text-gray-500 mr-2" />
              <input
                type="text"
                name="name"
                placeholder="Nhập họ và tên của bạn"
                value={formData.name}
                onChange={handleChange}
                className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
              />
            </div>
            <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
              <MdOutlineMailOutline className="text-gray-500 mr-2" />
              <input
                type="text"
                name="email"
                placeholder="Nhập email của bạn"
                value={formData.email}
                onChange={handleChange}
                className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
              />
            </div>
            <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
              <FiPhone className="text-gray-500 mr-2" />
              <input
                type="text"
                name="phone"
                placeholder="Nhập số điện thoại của bạn"
                value={formData.phone}
                onChange={handleChange}
                className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
              />
            </div>
          </div>
          <div className="flex items-center justify-center">
            <Button
              onClick={handleSubmit}
              disabled={isLoading}
              className={`flex items-center justify-center h-[54px] bg-[#053CC8] hover:bg-pa rounded-[40px] ${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? "Đang gửi..." : "Đăng ký nhận bản tin mới nhất"}
            </Button>
          </div>
        </div>
        <div>
          <img
            src={rg_mobi}
            alt="rg4"
            className="block md:hidden w-full h-auto object-cover"
          />
          <img
            src={rg_mobi}
            alt="rg5"
            className="hidden md:block w-full h-auto object-cover"
          />
        </div>
      </div>
    </div>
  );
}
